/** @format */

import React, { useContext, useState } from "react";
import { mainDataArray, partnersArray, shippingArray } from "./Fields";
import { OrderContext } from "../Contex";
import { FieldsReducer } from "./../../../../CommonComponents/Reducer/Index";
import PartnerField from "../../../../CommonComponents/EnhancedFields/Partner/PartnerField";
import PartnerList from "../../../../CommonComponents/DropDowns/Partner/PartnerList";

import LeaseField from "../../../../CommonComponents/EnhancedFields/Lease/LeaseField";
import LeaseList from "../../../../CommonComponents/DropDowns/Lease/LeaseList";

export default function MainTab() {
  const {
    onChange,
    operation,
    dropDowns,
    _orderData,
    _partnerList,
    _getPartnerList,
    _leaseList,
    _getLeaseList,
  } = useContext(OrderContext);

  const [showPartnerList, setShowPartnerList] = useState(false);
  const [showLeaseList, setShowLeaseList] = useState(false);

  const [partnerFieldName, setPartnerFieldName] = useState();
  const [leaseFieldName, setLeaseFieldName] = useState();

  const mergedFieldData = (field) => {
    let newFieldObject = { ...field, dataSource: _orderData, onChange };

    switch (operation) {
      case "Display":
        newFieldObject.disabled = true;
        break;
      case "Change":
        if (newFieldObject.key) {
          newFieldObject.disabled = true;
        }
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        //Disabling the order type after the create becuase number range depends on it
        if (field.editableCreateONLY === true) {
          if (_orderData[field.id]) {
            newFieldObject.disabled = true;
          }
        }

        break;
      case "Create":
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      default:
    }

    return newFieldObject;
  };
  const fieldsState = {
    dataSource: _orderData,
    dropDowns,
  };

  const mainDataFieldsToRender = mainDataArray(fieldsState);
  const partnerFieldsRender = partnersArray(fieldsState);
  const shippingFieldsRender = shippingArray(fieldsState);

  var soldtofield  = partnerFieldsRender.find(({ id }) => id === "soldtoId");
  var driverfield  = partnerFieldsRender.find(({ id }) => id === "driverId");
  var shiptofield  = partnerFieldsRender.find(({ id }) => id === "shiptoId");
  var carrierfield = partnerFieldsRender.find(({ id }) => id === "carrierId");
  var leaseField   = partnerFieldsRender.find(({ id }) => id === "leaseId");
  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-lg-4 col-sm-6 col-xs-12">
          <div className="card" style={{ minHeight: 480 }}>
            <div className="cardHeader">
              <h2>Main Data </h2>
            </div>
            <div className="cardBody">
              {mainDataFieldsToRender.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-sm-6 col-xs-12">
          <div className="card" style={{ minHeight: 480 }}>
            <div className="cardHeader">
              <h2>Partners</h2>
            </div>
            <div className="cardBody">
              <PartnerField
                field={mergedFieldData(soldtofield)}
                setShowList={setShowPartnerList}
                _getPartnerList={_getPartnerList}
                setPartnerFieldName={setPartnerFieldName}
                dropDownApiPartnerType="SOLDTO"
              />
              <PartnerField
                field={mergedFieldData(shiptofield)}
                setShowList={setShowPartnerList}
                _getPartnerList={_getPartnerList}
                setPartnerFieldName={setPartnerFieldName}
                dropDownApiPartnerType="SHIPTO"
              />
              <PartnerField
                field={mergedFieldData(driverfield)}
                setShowList={setShowPartnerList}
                _getPartnerList={_getPartnerList}
                setPartnerFieldName={setPartnerFieldName}
                dropDownApiPartnerType="DRIVER"
              />
              <PartnerField
                field={mergedFieldData(carrierfield)}
                setShowList={setShowPartnerList}
                _getPartnerList={_getPartnerList}
                setPartnerFieldName={setPartnerFieldName}
                dropDownApiPartnerType="CARRIER"
              />
               <LeaseField
                field={mergedFieldData(leaseField)}
                setShowLeaseList={setShowLeaseList}
                _getLeaseList={_getLeaseList}
                setLeaseFieldName={setLeaseFieldName}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-sm-6 col-xs-12">
          <div className="card" style={{ minHeight: 480 }}>
            <div className="cardHeader">
              <h2>Shipping</h2>
            </div>
            <div className="cardBody">
              {shippingFieldsRender.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <PartnerList
            _partnerList={_partnerList}
            showPartnerList={showPartnerList}
            setShowPartnerList={setShowPartnerList}
            partnerFieldName={partnerFieldName}
            onChange={onChange}
          />
           <LeaseList
            _leaseList={_leaseList}
            showLeaseList={showLeaseList}
            setShowLeaseList={setShowLeaseList}
            leaseFieldName={leaseFieldName}
            onChange={onChange}
          />
        </div>
      </div>
    </>
  );
}
